<template>
  <div id="app" class="app">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "app",
  data() {
    return {
      isAdmin: true
    };
  }
};
</script>

<style lang="scss">
@import "../sass/main.scss";

.your-custom-class {
  background-color: red !important;
}

body {
  height: 100%;

  #app {
    height: 100%;
  }
}
</style>
